// extracted by mini-css-extract-plugin
export default {"main_page":"About_main_page__A14Lw","s_box":"About_s_box__gWQwZ"};